<main @fade>
    <button class="catalog-name-trigger" type="button" *ngIf="device.isMobile" (click)="openCatalogSelector()">
        {{ catalog?.header || 'Каталог' }}
    </button>

    <button class="catalog-filter-trigger" type="button" *ngIf="device.isMobile" (click)="openMobileFilter()">
        <nb-icon icon="funnel-outline"/>
        <span i18n="@@OpenFilter">Открыть фильтр</span>
    </button>

    <app-catalog-level-selector *ngIf="device.isMobile"/>

    <app-catalog-mobile-filter *ngIf="device.isMobile" [filter]="productFilterService" [catalog]="catalog"/>

    <div class="head" *ngIf="!device.isMobile">
        <app-filter-panel [showHasStock]="!isShowcase" [filter]="productFilterService" [catalog]="catalog"/>
    </div>
    <button
            class="toggle-tiles-btn"
            *ngIf="!isLeafCategory"
            (click)="toggleSubcategories()"
            [title]="showSubcategories ? 'Скрыть плитки' : 'Показать плитки'">
           <nb-icon icon='collapse-outline'/>
        {{ showSubcategories ? 'Скрыть подкатегории' : 'Показать подкатегории' }}
    </button>
    <app-catalog-subcategories [categoryId]="currentCategoryId"
                               *ngIf="showSubcategories"
                               (isLeaf)="onIsLeaf($event)"/>
    <app-last-category *ngIf="isLeafCategory"
                       [catalog]="catalogFeature"/>

    <div class="head" *ngIf="!device.isMobile">
        <div class="view-wrapper">
<!--            Вы также можете подобрать товары через конфигуратор-->
<!--            <button class="btn-gray">-->
<!--                Конфигуратор товаров-->
<!--            </button>-->
        </div>
        <div class="select-view-panel" (click)="showProductBlocks()">
            <div class="select-view-panel__slider" [ngClass]="{'right': isShowProductList}"></div>
            <div class="select-view-panel__item" [ngClass]="{'active': !isShowProductList}">
                <nb-icon icon="grid-outline"/>
            </div>
            <div class="select-view-panel__item" [ngClass]="{'active': isShowProductList}">
                <nb-icon icon="list-outline"/>
            </div>
        </div>
    </div>
    <app-customer-product-table [searchKeyword]="queryParams?.keyword" [productList]="productList$ | async"
                                [pagination]="pagination"
                                *ngIf="!isShowProductList"/>

    <app-customer-product-list [searchKeyword]="queryParams?.keyword" [productList]="productList$ | async"
                               [pagination]="pagination"
                               [isShowcase]="isShowcase"
                               *ngIf="isShowProductList"/>

</main>
